import {Injectable} from '@angular/core';
import {RefundsResponse} from '@npck/af-frontend-api';
import {RouterService} from '@npck/libs/commons';
import dayjs from 'dayjs';
import {FilterEvent} from '../components/full-table/filter/filter.component';
import {initialTableEvent, TableEvent} from '../components/full-table/full-table.component';
import {RefundsTab, RefundTabInfo} from '../pages/refunds/refunds.component';
import {Path} from '../path';
import {AuthHolderService} from './auth-holder.service';

@Injectable({providedIn: 'root'})
export class RefundsFilterHolderService {
    private tabs: RefundsTab[] = ['tabAllRefunds', 'tabMyRefunds', 'tabRelatedRefunds', 'tabOrganizationsRefunds'];

    private tabTableHolder = this.initialState();

    constructor(
        private authHolderService: AuthHolderService,
        private routerService: RouterService,
    ) {
        this.routerService.navigationEnd()
            .subscribe(event => {
                if (!event.url.includes(Path.REFUNDS)) {
                    this.clear();
                }
            });
    }

    storeTableState(tab: RefundsTab, tableEvent: TableEvent): RefundTabInfo {
        const activeTabState = this.tabTableHolder[tab];
        const defaultFilterForTab = this.getDefaultFilterForTab(tab);
        this.tabTableHolder[tab] = {
            ...activeTabState,
            tableEvent: {
                ...tableEvent,
                filter: {
                    ...tableEvent.filter,
                    ...defaultFilterForTab,
                    refundRelatedOrganizations: {
                        ...tableEvent.filter?.refundRelatedOrganizations ?? {},
                        ...(defaultFilterForTab.refundRelatedOrganizations ?? {}),
                    },
                },
            },
        };
        return this.tabTableHolder[tab];
    }

    storeResponse(tab: RefundsTab, response: RefundsResponse): void {
        this.tabTableHolder[tab] = {...this.tabTableHolder[tab], response: response, cachedTime: dayjs()};
    }

    getState(activeTab: RefundsTab): RefundTabInfo {
        return this.tabTableHolder[activeTab];
    }

    clear(): void {
        this.tabTableHolder = this.initialState();
    }

    private getDefaultFilterForTab(tab: RefundsTab): FilterEvent {
        switch (tab) {
            case 'tabAllRefunds':
                return {};
            case 'tabMyRefunds':
                return {
                    refundCreatedByUsername: this.authHolderService.username,
                };
            case 'tabRelatedRefunds':
                return {
                    refundRelatedOrganizations: {[this.authHolderService.organizationBin]: true},
                    refundExcludeAuthorOrganizations: [this.authHolderService.organizationBin],
                };
            case 'tabOrganizationsRefunds':
                return {
                    refundOrganizations: [this.authHolderService.organizationBin],
                };
        }
    }

    private initialState(): Record<RefundsTab, RefundTabInfo> {
        return this.tabs.reduce((acc, item) => {
            if (!acc[item]) {
                acc[item] = <RefundTabInfo>{
                    tableEvent: {
                        ...initialTableEvent,
                        filter: this.getDefaultFilterForTab(item),
                    },
                };
            }
            return acc;
        }, {} as Record<RefundsTab, RefundTabInfo>);
    }
}
